import "./styles.scss";

import * as Yup from "yup";
import { FormHandles } from "@unform/core";
import { Form } from "@unform/web";

import { useCallback, useRef, useState } from "react";

import { sendGchat } from "~/services/gchat";
import NewChatButton from "~/components/NewChatButton";
import OfflineChat from "~/components/OfflineChat";
import FormSend from "~/components/FormSend";
import Input from "~/components/Input";
import Select from "~/components/Select";

// Define uma interface para as propriedades do componente
interface IChatListProps {
  showOffChat: boolean;
  setShowOffChat: (value: boolean) => void;
}

// Define o componente ChatContact, que recebe as propriedades especificadas na interface
const ChatContact: React.FC<IChatListProps> = ({
  showOffChat,
  setShowOffChat,
}) => {
  // Cria uma referência para o formulário
  const formRef = useRef<FormHandles>(null);

  // Define um estado para controle de carregamento
  const [loading, setLoading] = useState<boolean>(false);

  // Define um estado para controle de envio do formulário
  const [formSubmitted, setFormSubmitted] = useState(false);

  // Define um estado para o número de telefone
  const [phone, setPhone] = useState("");

  // Opções para o campo "whatsapp"
  const options = [
    {
      value: 1,
      description: "Sim",
    },
    {
      value: 2,
      description: "Não",
    },
  ];

  // Função para lidar com o envio do formulário
  const onSubmitExternal = useCallback(
    async data => {
      try {
        // Define um esquema de validação usando a biblioteca Yup
        const schema = Yup.object().shape({
          name: Yup.string().required("Esse campo é obrigatório"),
          phone: Yup.string().required("Esse campo é obrigatório"),
          email: Yup.string()
            .email("Digite um e-mail válido")
            .required("Esse campo é obrigatório"),
          whatsapp: Yup.string()
            .required("Esse campo é obrigatório")
            .equals(["1", "2"], "Escolha uma opção"),
          doubt: Yup.string().required("Esse campo é obrigatório"),
        });

        // Valida os dados do formulário com base no esquema
        await schema.validate(data, {
          abortEarly: false,
        });

        // Limpa os erros do formulário
        formRef.current?.setErrors({});

        // Obtém a data e hora atual
        const now = new Date();

        // Verifica se o chat está offline com base no horário e dia da semana
        if (
          now.getHours() < 9 ||
          now.getHours() >= 18 ||
          now.getDay() === 6 ||
          now.getDay() === 0
        ) {
          // Define o chat como offline
          setShowOffChat(true);
        } else {
          // Define o estado de carregamento como true
          setLoading(true);

          // Obtém a URL atual do navegador
          const currentURL = window.location.href;

          let companyName = "";

          if (currentURL.includes("configr.com")) {
            companyName = "configr";
          } else if (currentURL.includes("cloudez.io")) {
            companyName = "cloudez";
          }

          let text = "";

          if (companyName === "configr") {
            text = "💜 Configr 💜";
          } else if (companyName === "cloudez") {
            text = "💙 Cloudez 💙";
          } else {
            text = "💛 Outro 💛";
          }

          // Envia uma mensagem para o Google Chat com os dados do formulário
          await sendGchat({
            text: `${text}\n👤 Nome: ${data.name}\n📧 E-mail: ${
              data.email
            }\n📱 Telefone: ${data.phone.replace(
              /[^0-9]/g,
              "",
            )}\n🤳🏻 É WhatsApp?: ${
              data.whatsapp === "1" ? "Sim" : "Não"
            }\n💬 Dúvida: ${data.doubt}`,
          });
          // Define o estado de carregamento como false
          setLoading(false);
          // Define o estado de envio do formulário como true
          setFormSubmitted(true);
        }
      } catch (e) {
        if (e instanceof Yup.ValidationError) {
          // Se houver erros de validação, define os erros no formulário
          const errorMessages = {} as any;
          e.inner.forEach((error: any) => {
            errorMessages[error.path] = error.message;
          });

          formRef.current?.setErrors(errorMessages);
        }
        // Define o estado de carregamento como false
        setLoading(false);
        console.log(e);
      }
    },
    [phone],
  );

  return (
    <div className="content">
      <>
        {showOffChat ? (
          // Se o chat estiver offline, exibe o componente OfflineChat
          <OfflineChat />
        ) : (
          formSubmitted && (
            // Renderize o componente FormSend após o envio bem-sucedido
            <FormSend />
          )
        )}
        {!showOffChat && !formSubmitted && (
          // Se o chat estiver online, exibe o formulário de contato
          <div className="formClient">
            <p>Entre em contato com nossos especialistas.</p>
            <p>Estaremos prontos para lhe ajudar!</p>
            <Form ref={formRef} onSubmit={onSubmitExternal}>
              <Input name="name" label="Nome" placeholder="Insira o seu nome" />
              <Input
                name="email"
                label="E-mail"
                placeholder="Insira o seu e-mail"
              />
              <Input
                name="phone"
                label="Telefone"
                maskPlaceholder="Insira o seu telefone"
                isMask
                mask="(99) 99999-9999"
                value={phone}
                setValue={setPhone}
              />
              <Select name="whatsapp" label="É WhatsApp?">
                <option disabled value={0}>
                  Escolha uma opção
                </option>
                {options.map(option => (
                  <option key={option.description} value={option.value}>
                    {option.description}
                  </option>
                ))}
              </Select>
              <Input
                isMulti
                name="doubt"
                label="Qual é a sua dúvida?"
                placeholder="Descreva a sua dúvida"
              />
              <NewChatButton
                style={{ width: "200px", margin: "10px 0 10px 0" }}
                loading={loading}
                title="SOLICITAR CONTATO"
                type="submit"
              />
            </Form>
          </div>
        )}
      </>
    </div>
  );
};

export default ChatContact;
